import React from "react";
import "./sass/bopis-option.scss";
import PickupDetails from "../below-belt/pick-up-details";

function BopisOption({
  selected = true,
  select = () => {},
  details,
  fulfillmentDetails={},
}) {
  const {
    store,
    enabled,
    inventory,
    available,
    useNearby,
    nearbyStore,
  } = details ;
  let isPurchasableInLocalStoreInStock, isZeroStockInLocalStoreActive;
  ({
    isPurchasableInLocalStoreInStock,
    isZeroStockInLocalStoreActive
  } = fulfillmentDetails || false);
  const storeName = store ? store.storeName : "NOT LOCALIZED";
  
  const localStoreStockQuantity =
    inventory.store
      ? inventory.store.quantity
      : "";

  let cardClasses =
    "pickupTile card card-container card-background ";
  cardClasses += selected ? "card-selected " : "card-unselected ";
  cardClasses += enabled ? "card-enabled " : "card-unselected ";

  const pickUpText =  fulfillmentDetails.showBopisCovidAlert ? <span className="dai_tileMessage">Available</span> : <span className="dai_tileMessage">Pickup</span>;
  const pickupDay =  fulfillmentDetails.showBopisCovidAlert ? '': 'Today';


  const showNotAvailableForItem = (
      !details.isInventoryRestricted 
      && fulfillmentDetails.isStoreAssortmentRestricted
      && !details.limitedStock 
      && !details.limitedStockNearbyStore
    );

  let showUnavailableAtStore = false;
  if(
      fulfillmentDetails.availabilityType === "Browse Only"
      && fulfillmentDetails.bopisEligible
      &&
      (
        (!fulfillmentDetails.isAssortedToLocalStore  
          && !details.limitedStock 
          && !details.limitedStockNearbyStore)
        ||
        (fulfillmentDetails.isOosAtStore && fulfillmentDetails.isOosAtNearbyStore)
        ||
        (fulfillmentDetails.storeStatusCode==="500" || fulfillmentDetails.storeStatusCode==="600")
      )
      
  ){
    showUnavailableAtStore = true;
  }else if(     
        fulfillmentDetails.availabilityType === "Shared"
        && fulfillmentDetails.bopisEligible
        && (
         (
          !details.limitedStock 
          && !details.limitedStockNearbyStore        
        &&
        (
          (fulfillmentDetails.isOosAtStore && fulfillmentDetails.isOosAtNearbyStore)
          ||
          // (fulfillmentDetails.storeStatusCode==="500" || fulfillmentDetails.storeStatusCode==="600")
          // ||
          (!fulfillmentDetails.thdBrowseOnlinestatus && !fulfillmentDetails.bossEligibleCatalog)
        )
        )) ||
         (
          (details.limitedStock || details.limitedStockNearbyStore)
          && (fulfillmentDetails.storeStatusCode==="500" || fulfillmentDetails.storeStatusCode==="600")
        ) ||
          (!fulfillmentDetails.isAssortedToLocalStore)
        
  ){
      showUnavailableAtStore = true;
  }

  //also, handle Shared

  if (isPurchasableInLocalStoreInStock) {
    cardClasses.replace("card-enabled", "");
    return (
      <div className={cardClasses}>
        <div className="pickup-in-store__wrapper pickup-in-store__wrapper--disabled">
          <div className="pickup-in-store__icon pick-up-false"/>
          <div className="tile-heading pickup-in-store__heading dai_tileHeading">
            In-Store Purchase
          </div>
          <div className="tile-message pickup-in-store__message dai_tileMessage">
            <span>Available</span>
          </div>
          <div className="dai_tilePrice pickup-in-store__message--purchase-in-store">
            <div className="storeNameWrapper">{storeName}</div>
            <div className="u__text--success ">
              <span className="u__bold" >{`${localStoreStockQuantity} `}</span>
              in stock
            </div>
          </div>
        </div>
      </div>
    );
  } else if (isZeroStockInLocalStoreActive) {
    cardClasses.replace("card-enabled", "");
    return (
      <div className={cardClasses}>
        <div className="pickup-in-store__wrapper pickup-in-store__wrapper--disabled">
          <div className="pickup-in-store__icon pick-up-false"/>
          <div className="tile-heading pickup-in-store__heading dai_tileHeading">
            In-Store Purchase
          </div>
          <div className="tile-message pickup-in-store__message pickup-in-store__message--purchase-in-store dai_tileMessage">
            Visit your store to check availability
          </div>
        </div>
      </div>
    );
  } else if (available) {
    return (
        <div className={cardClasses} onClick={() => enabled && select("PICKUP")}>
          <div
              className={
                "pickup-in-store__wrapper " +
                (enabled ? "" : "pickup-in-store__wrapper--disabled")}
          >
            <div>
              <div
                  className={
                    "pickup-in-store__icon pick-up-" + (enabled ? "true" : "false")
                  }
              ></div>
              <div className="tile-heading pickup-in-store__heading dai_tileHeading">
                Store Pickup
              </div>
            </div>
            <div className="pickup-in-store__message-wrapper">
              <div className="tile-message pickup-in-store__message">
                <div className="" data-automation-id="fulfillmentMessageText">
                  {pickUpText}
                </div>
              </div>
              <div className="tile-date pickup-in-store__message pickup-in-store__message--bold">
              <span className="dai_tileDate">
                {pickupDay?pickupDay:"\u00a0"}
                {useNearby
                    ? " (" + nearbyStore.distance + " mi)"
                    : ""}
              </span>
              </div>
            </div>
          </div>
          <div className="u__center card-messaging-bottom card-messaging-price" >
          <div className="u__text--success dai_tilePrice">
            {enabled && "FREE"}
            {!enabled && "This item can only be purchased in stores"}
          </div>
          </div>
        </div>
    );
  } else if(showUnavailableAtStore) {
      cardClasses.replace("card-enabled", "");
          return (
            <div className={cardClasses}>
              <div className="pickup-in-store__wrapper pickup-in-store__wrapper--disabled">
                <div className="">
                  <div className="pickup-in-store__icon pick-up-false"></div>
                  <div className="tile-heading pickup-in-store__heading dai_tileHeading">
                    Store Pickup
                  </div>
                </div>
                <div className="pickup-in-store__message-wrapper">
                  <div className="tile-message pickup-in-store__message">
                    <div className="dai_tileMessage">
                      <span>
                          {`Unavailable at `}
                      </span>
                      <div className="storeNameWrapper">
                        {storeName}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-messaging-nearbystore">
                <span className="u__text--success dai_tilePrice">
                  <div className="dai_pickupTileMessage_checkNearby">
                    <a
                      href="#"
                      className="u__default-link store-inventory-finder-trigger"
                    >
                      Check Nearby Stores
                    </a>
                  </div>
                </span>
              </div>
            </div>
          );
  }  else if(showNotAvailableForItem) {
    cardClasses.replace("card-enabled", "");
        return (
          <div className={cardClasses}>
            <div className="pickup-in-store__wrapper pickup-in-store__wrapper--disabled">
              <div className="">
                <div className="pickup-in-store__icon pick-up-false"></div>
                <div className="tile-heading pickup-in-store__heading dai_tileHeading">
                  Store Pickup
                </div>
              </div>
              <div className="pickup-in-store__message-wrapper">
                <div className="tile-message pickup-in-store__message">
                  <div className="">
                   <div id="unavailable-text" className="dai_tileMessage">
                      Not available for this item
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-messaging-nearbystore">
              <span className="u__text--success dai_tilePrice">
                <div className="dai_pickupTileMessage_checkNearby">
                  <a
                    href="#"
                    className="u__default-link store-inventory-finder-trigger"
                  >
                    Check Nearby Stores
                  </a>
                </div>
              </span>
            </div>
          </div>
        );
  }else {
    cardClasses.replace("card-enabled", "");
    return (
      <div className={cardClasses}>
        <div className="pickup-in-store__wrapper pickup-in-store__wrapper--disabled">
          <div className="">
            <div className="pickup-in-store__icon pick-up-false"></div>
            <div className="tile-heading pickup-in-store__heading dai_tileHeading">
              Store Pickup
            </div>
          </div>
          <div className="pickup-in-store__message-wrapper">
            <div className="tile-message pickup-in-store__message">
              <div className="dai_tileMessage">
                {!details.limitedStock && !details.limitedStockNearbyStore && (
                  <>
                    <span>
                      {`0 in stock at `}
                    </span>
                    <div className="storeNameWrapper">
                      {storeName}
                    </div>
                  </>
                )}
                {(details.limitedStock || details.limitedStockInventoryRestricted || details.limitedStockNearbyStore) && (
                  <>
                    <span className="warning_text">Limited stock at </span>
                    <div className="storeNameWrapper warning_text">
                      {details.limitedStockNearbyStore?nearbyStore.name:storeName} 
                    </div> 
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="card-messaging-nearbystore">
          <span className="u__text--success dai_tilePrice">
            <div className="dai_pickupTileMessage_checkNearby">
              <a
                href="#"
                className="u__default-link store-inventory-finder-trigger"
              >
                Check Nearby Stores
              </a>
            </div>
          </span>
        </div>
      </div>
    );
  } 
}

export default BopisOption;
